var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.open,
            title: "Add well",
            width: "6.5rem",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
            close: _vm.handleCancel,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "AER UWI", prop: "UWI", rules: _vm.uwiRules },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please fill in",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.UWI,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "UWI", $$v)
                      },
                      expression: "form.UWI",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "FromToIDIdentifier",
                    prop: "fromToIDIdentifier",
                    rules: _vm.fromToRules,
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please fill in",
                      autocomplete: "off",
                    },
                    model: {
                      value: _vm.form.fromToIDIdentifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fromToIDIdentifier", $$v)
                      },
                      expression: "form.fromToIDIdentifier",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Contains assets",
                    prop: "type",
                    rules: _vm.typeRules,
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { label: "OIL", name: "type" },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: { label: "GAS", name: "type" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("Cancel"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: { click: _vm.handleSubmite },
                },
                [_vm._v("\n        Submit\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }